// Palette

import palette, { themeColorTokens } from '../palette';

export default {
  root: {
    backgroundColor: palette.primary.light,
    color: themeColorTokens.chipText,
  },
  clickable: {
    '&:hover, &:focus, &:active': {
      backgroundColor: themeColorTokens.chipHoverBackground,
    },
  },
  deletable: {
    '&:focus': {
      backgroundColor: palette.primary.light,
    },
  },
  outlined: {
    '&:hover': {
      backgroundColor: palette.primary.light,
    },
  },
};
